/* Feb-2026 · "Save Pulse Sound" — a short, gentle two-note chime that
 * accompanies the visual pulse on the Save & Sign Out button, fired once
 * the moment there are unsaved changes (not on every keystroke, and not
 * repeatedly while it stays dirty). Synthesized with the Web Audio API
 * so no audio asset is needed and the volume/pitch can stay deliberately
 * soft — this is a reminder, not an alert.
 */
let _ctx = null;
function getCtx() {
  if (_ctx) return _ctx;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  _ctx = new Ctx();
  return _ctx;
}

function tone(ctx, freq, startAt, duration, peakGain) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = 'sine';
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0, startAt);
  gain.gain.linearRampToValueAtTime(peakGain, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.001, startAt + duration);
  osc.connect(gain);
  gain.connect(ctx.destination);
  osc.start(startAt);
  osc.stop(startAt + duration + 0.02);
}

export function playSaveReminderChime() {
  try {
    const ctx = getCtx();
    if (!ctx) return;
    if (ctx.state === 'suspended') ctx.resume().catch(() => {});
    const now = ctx.currentTime;
    // Two soft notes, a rising fourth (A4 → D5) — reads as a gentle
    // "heads up", not an alarm.
    tone(ctx, 440.0, now,        0.22, 0.05);
    tone(ctx, 587.33, now + 0.11, 0.26, 0.05);
  } catch { /* delight-only — never let a chime failure affect saving */ }
}
